import { useTranslation } from 'react-i18next';
import { TableRow, TableCell } from '@mui/material';
import { CookieInfo } from './Cookies';
import { SplitterTableRow } from './CookieDetailBody.styled';

interface CookieDetailBodyProps {
  cookieType: string;
  index: number;
  cookieInfo: CookieInfo;
  isLast: boolean;
}

const CookieDetailBody: React.FC<CookieDetailBodyProps> = ({ cookieType,
                                                             index,
                                                             cookieInfo,
                                                             isLast }) => {
  const { t } = useTranslation();

  const showRow = (rowValue: string | null) => {
    if (typeof rowValue === 'string' && rowValue.trim().length === 0) {
      return false;
    }
    if (rowValue === null) {
      return false;
    }

    return true;
  };

  const anyRowShown = () => {
    return (
      showRow(cookieInfo?.name) ||
      showRow(cookieInfo?.provider) ||
      showRow(cookieInfo?.purpose) ||
      showRow(cookieInfo?.duration)
    );
  };

  return (
    <>
      {showRow(cookieInfo?.name) && (
        <TableRow data-testid={`${cookieType}-cookies-tr-name-${index}`}>
          <TableCell align="left">{t('cookies.cookie-statement.content.cookieOverview.rowHeaders.name')}</TableCell>
          <TableCell align="left">{cookieInfo.name}</TableCell>
        </TableRow>
      )}
      {showRow(cookieInfo?.provider) && (
        <TableRow data-testid={`${cookieType}-cookies-tr-provider-${index}`}>
          <TableCell align="left">{t('cookies.cookie-statement.content.cookieOverview.rowHeaders.provider')}</TableCell>
          <TableCell align="left">{cookieInfo.provider}</TableCell>
        </TableRow>
      )}
      {showRow(cookieInfo?.purpose) && (
        <TableRow data-testid={`${cookieType}-cookies-tr-purpose-${index}`}>
          <TableCell align="left">{t('cookies.cookie-statement.content.cookieOverview.rowHeaders.purpose')}</TableCell>
          <TableCell align="left">{cookieInfo.purpose}</TableCell>
        </TableRow>
      )}
      {showRow(cookieInfo?.duration) && (
        <TableRow data-testid={`${cookieType}-cookies-tr-duration-${index}`}>
          <TableCell align="left">{t('cookies.cookie-statement.content.cookieOverview.rowHeaders.duration')}</TableCell>
          <TableCell align="left">{cookieInfo.duration}</TableCell>
        </TableRow>
      )}
      {!isLast && anyRowShown() && (
        <SplitterTableRow data-testid={`${cookieType}-cookies-tr-empty-${index}`}>
          <TableCell align="left">&nbsp;</TableCell>
          <TableCell align="left">&nbsp;</TableCell>
        </SplitterTableRow>
      )}
    </>
  );
};

export default CookieDetailBody;
